import { useMachine } from '@xstate/react'
import { requestMachine } from 'machines/requestMachine'
import { useLocationsActions } from 'providers'
import { useCallback } from 'react'
import { TeachingLocation, UpdateLocationProps } from 'types/location'

export const useUpdateLocation = (): [
  (locationData: UpdateLocationProps) => void,
  TeachingLocation | undefined,
  boolean,
  string
] => {
  const [state, send] = useMachine(requestMachine)
  const { update: updateLocation } = useLocationsActions()

  const update = useCallback(
    (locationData: UpdateLocationProps) => {
      const promise = updateLocation(locationData)
      send('SET_PROMISE', { data: promise })
    },
    [send, updateLocation]
  )

  const updatedLocation = state.matches('success') && state.context.data
  const errorMessage = state.matches('failed') ? state.context.error : ''
  const loading = state.matches('syncing')

  return [update, updatedLocation, loading, errorMessage]
}
